import { anchorLink } from "../include/module";
import { mainNavCurrent } from "../include/module";
import { modalPopup } from "../include/module";
import { showMovie } from "../include/module";
anchorLink();
mainNavCurrent();
modalPopup();
showMovie();



// WEBPACK FOOTER //
// ./src/assets/js/band/script.js